import { Currency } from '@reservoir0x/reservoir-kit-ui'
import { reservoirChains } from '@reservoir0x/reservoir-sdk'
import wrappedContracts from './wrappedContracts'
import { zeroAddress } from 'viem'
import {
  polygon,
  Chain,
} from 'wagmi/chains'
import usdcContracts from './usdcContracts'
import {getCurrencies} from '@rcax/common'

//CONFIGURABLE: The default export controls the supported chains for the marketplace. Removing
// or adding chains will result in adding more or less chains to the marketplace.
// They are an extension of the wagmi chain objects

export type ReservoirChain = Chain & {
  lightIconUrl: string
  darkIconUrl: string
  reservoirBaseUrl: string
  proxyApi?: string
  routePrefix: string
  apiKey?: string
  coingeckoId?: string
  collectionSetId?: string
  community?: string
  wssUrl?: string
  listingCurrencies?: Currency[]
  oracleBidsEnabled?: boolean
}

const nativeCurrencyBase = {
  contract: zeroAddress,
  symbol: 'ETH',
  decimals: 18,
  coinGeckoId: 'ethereum',
}

const usdcCurrencyBase = {
  contract: '',
  symbol: 'USDC',
  decimals: 6,
  coinGeckoId: 'usd-coin',
}

export const DefaultChain: ReservoirChain = {
  ...polygon,
  lightIconUrl: '/icons/polygon-icon-dark.svg',
  darkIconUrl: '/icons/polygon-icon-light.svg',
  reservoirBaseUrl: reservoirChains.polygon.baseApiUrl,
  proxyApi: '/api/reservoir/polygon',
  routePrefix: '',
  coingeckoId: 'matic-network',
  collectionSetId: process.env.NEXT_PUBLIC_POLYGON_COLLECTION_SET_ID,
  community: process.env.NEXT_PUBLIC_POLYGON_COMMUNITY,
  wssUrl: 'wss://ws-polygon.reservoir.tools',
  listingCurrencies: getCurrencies(),
  oracleBidsEnabled: true,
}

export default [DefaultChain] as ReservoirChain[]
